import { FieldError, useController, UseControllerProps, useWatch } from 'react-hook-form';
import { TextField, TextFieldProps } from './TextField.tsx';
import { Box } from '@mui/material';
import { get } from 'lodash';

export interface OptionalTextFieldProps {
  control: UseControllerProps['control'];
  dependsOn: {
    disabled: boolean;
    name: string;
    value: string;
  };
  textField: {
    rules?: UseControllerProps['rules'];
  } & Omit<TextFieldProps, 'onChange' | 'error' | 'value'>;
}

/*
 * This text field is designed to be used as an additional text field for a checkbox or radio fields.
 * can be extended to other fields as well.
 * */
export const OptionalTextField = ({ control, dependsOn, textField }: OptionalTextFieldProps) => {
  const watchValue = useWatch({ control, name: dependsOn.name });
  const disabledByValue = isDisabled(watchValue, dependsOn.value);

  const disabled = disabledByValue || dependsOn.disabled;

  const {
    field: { value, onChange },
    formState: { errors },
  } = useController({
    disabled,
    name: textField.name,
    control,
    rules: textField?.rules,
  });

  return (
    <Box display="flex" flexDirection="column">
      <TextField {...textField} fullWidth={false} disabled={disabled} value={value} onChange={onChange} error={get(errors, textField.name) as FieldError} />
    </Box>
  );
};

const isDisabled = (watchValue: string[] | string, dependsValue: string) => {
  if (Array.isArray(watchValue)) {
    return !watchValue.includes(dependsValue);
  }

  return watchValue !== dependsValue;
};
